const UK_STRINGS = {
  currency: '£',
  eircode: 'Postcode',
  'outlet.search.placeholder': 'Search by outlet id, customer number, outlet name, Postcode...',
  'outlet.validation.customerNumber': 'Customer Unique Number',
  'outlet.validation.customerNumber.tooltip': "If you don't know your customer number please contact your Imperial Brands Representative",
  'outlet.validation.eircode': 'Full Store Postcode',
  'outlet.validation.eircode.tooltip': "If you don't know your Postcode please contact your Imperial Brands Representative",
  packsSold: 'Outers Sold',
  pointsPerPack: 'Points per outer',
  'pointsPerPack.up': 'Points per outer up to target',
  'pointsPerPack.post': 'Points per outer post target',
  'pointsPerPack.over': 'Points per outer over target',
  'pointsPerPack.before': 'Points per outer before target',
  'pointsPerPack.after': 'Points per outer after target',
  'registration.part1': 'An investment programme designed to help independent ' +
      'retailers achieve the highest standards of tobacco ' +
      'retailing and move their business forward.',
  'registration.part2': (
    <div>
      Registering for
      {' '}
      <strong>
        ignite
      </strong>
      {' '}
      is a simple process, you just need to have your store details handy.
    </div>
  ),
  'registration.disabled':
    'Registration for the ignite programme is temporarily unavailable as we are working on some improvements to the ignite website. ' +
    'Please check back soon',
  rsp: 'RRP',
  'rsp.withCurrency': 'RRP (£)',
  settings: 'Settings',
  'settings.saved.success': 'Outlet Reward settings saved successfully',
  'settings.saved.error': 'An error occurred during save Outlet Reward settings',
  'manualPointTransaction.note': 'Please note any points added here will be awarded ' +
      'as personal reward points and not outlet reward points.',
  'yourStore.iDontKnowEircode': 'I do not know my Postcode',
};

const UK_REGISTRATION_STRINGS = {
  ...UK_STRINGS,
  'registration.part1': 'Registering is easy, you just need your store details handy.',
  'registration.part2': 'If you need help please speak with your ' +
      'Imperial Brands Representative or use the contact us link at the bottom of this page.'
};

const t = identifier => UK_REGISTRATION_STRINGS[identifier];

export default t;
